function handleElementLoad(elementId, zIndex, callback) {
  const element = document.getElementById(elementId);
  if (element) {
    element.style.zIndex = zIndex;
    callback();
  }
}
function createObserver(elementId, zIndex) {
  return new MutationObserver(function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      const element = document.getElementById(elementId);
      if (mutation.type === "childList" && element) {
        handleElementLoad(elementId, zIndex, () => observer.disconnect());
        break;
      }
    }
  });
}
const smileObserver = createObserver("smile-ui-container", "2000");
const fondueObserver = createObserver("ps__widget_container", "999999");
const iframeObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.id === "launcher") {
        onIframeLoaded(node);
        iframeObserver.disconnect();
      }
    });
  });
});
smileObserver.observe(document.body, { childList: true, subtree: true });
fondueObserver.observe(document.body, { childList: true, subtree: true });
iframeObserver.observe(document.body, { childList: true, subtree: true });
function onIframeLoaded(iframe) {
  setupMutationObserver(iframe);
}
function setupMutationObserver(iframe) {
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if (mutation.type === "childList") {
        const button = iframeDoc.querySelector(
          'button[data-garden-id="buttons.icon_button"]'
        );
        if (button) {
          button.addEventListener("click", function () {
            layerPush({
              event: "popup_clicked",
              widgetEventData: {
                widget: "zendesk",
                path: "{{ request.path }}",
              },
            });
          });
          observer.disconnect();
          break;
        }
      }
    }
  });
  observer.observe(iframeDoc.body, { childList: true, subtree: true });
}
window.addEventListener("PandectesEvent_OnInitialize", () => {
  setTimeout(() => {
    try {
      if (
        isObjectValuesEmpty(Shopify.customerPrivacy.currentVisitorConsent())
      ) {
        Pandectes.fn.setPreferencesCheckboxes(8);
      }
    } catch (e) {
      //dismiss
    }
  }, 1000);
});
